import moment from 'moment-timezone';
import 'moment/locale/ru';

moment.locale('ru');
moment.tz.setDefault('Europe/Moscow');

export default moment;
